import {Component, OnInit} from "@angular/core";
import {AriadnextProfile} from "../../api/entity";
import {IntegrationModuleService} from "../../api/service";
import {ActivatedRoute} from "@angular/router";
import {AriadnextService} from "../../api/service/ariadnext.service";

@Component({
    selector: 'tfl-ariad-verification',
    host: {'class': 'verification-results-block'},
    template: `
        <loading-linear [loading]="loading"></loading-linear>
        <h3>
            <!--<button (click)="createApplicant()"-->
            <!--[disabled]="loading"-->
            <!--*ngIf="hasNotContactedWithAriadnext() && isSupported"-->
            <!--class="btn btn-primary verify-btn-box pull-right">-->
            <!--{{ 'CUSTOMER.VERIFICATION.ARIADNEXT.CREATE_APPLICANT' | translate }}-->
            <!--</button>-->

            {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.TITLE' | translate }}
        </h3>

        <hr/>

        <ng-container *ngIf="!isSupported">
            <h3 class="text-center">
                {{ 'CUSTOMER.VERIFICATION.ARIADNEXT.NOT_AVAILABLE' | translate }}
            </h3>
        </ng-container>

        <ng-container *ngIf="isSupported && ariadnextProfile">
            <tfl-bo-ariadnext-client-user
                *ngFor="let user of ariadnextProfile.attachedUsers"
                [profileId]="profileId"
                [user]="user"
                [loading]="loading">
            </tfl-bo-ariadnext-client-user>
        </ng-container>
    `
})
export class AriadVerificationComponent implements OnInit {

    ariadnextProfile: AriadnextProfile;
    loading = false;
    isSupported = true;
    profileId: number;

    constructor(private _ariadnextService: AriadnextService,
                private _integrationModuleService: IntegrationModuleService,
                private _activatedRoute: ActivatedRoute) {
    }

    ngOnInit(): void {
        this._activatedRoute.parent.parent.params.subscribe(params => {
            this.loading = true;
            this.profileId = +params['id'];
            this._integrationModuleService.getAvailabilityForClientProfile(this.profileId).subscribe(modules => {
                let foundModule = modules.find(m => m.name === 'ARIADNEXT');
                this.isSupported = foundModule.available;
                if(this.isSupported) {
                    this.fetchVerificationResults();
                } else {
                    this.loading = false;
                }
            });
        });
    }

    private fetchVerificationResults() {
        if (this.isSupported) {
            this.loading = true;
            this._ariadnextService
                .getResultByProfile(this.profileId)
                .subscribe(results => {
                    this.ariadnextProfile = results;
                    this.loading = false;
                });
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/ariadnext/ariad.verification.component.ts